import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';

export const scrollbarStyles = (theme: Theme): SystemStyleObject => ({
  '::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.transparency.alpha16,
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.transparency.alpha32,
    borderRadius: '3.5px',
  },
});
